export default "__VITE_ASSET__BVTkSr8B__"